import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=26c926cd&scoped=true"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&id=26c926cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c926cd",
  null
  
)

export default component.exports